// AuthProvider.jsx (simplified)
import { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        let snap = await getDoc(doc(db, "referral_users", firebaseUser.uid));
        if (!snap.exists()) {
          // Registration creates Auth first and Firestore profile immediately after.
          // Give the profile write a brief chance to land before force-signing out.
          for (let i = 0; i < 5 && !snap.exists(); i += 1) {
            await wait(250);
            snap = await getDoc(doc(db, "referral_users", firebaseUser.uid));
          }
        }
        if (snap.exists()) {
          setUser(firebaseUser);
          setUserData(snap.data());
        } else {
          await signOut(auth).catch(() => {});
          setUser(null);
          setUserData(null);
        }
      } else {
        setUser(null);
        setUserData(null);
      }
      setAuthLoading(false);
    });
    return () => unsub();
  }, []);

  // Optional: helper to refresh user data
  const refreshUserData = async () => {
    if (user) {
      const snap = await getDoc(doc(db, "referral_users", user.uid));
      setUserData(snap.exists() ? snap.data() : null);
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, userData, authLoading, refreshUserData }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
